export default __webpack_public_path__ + "static/media/book2.88d66698.jpg";